'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselButton", {
    enumerable: true,
    get: function() {
        return CarouselButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselButton = require("./useCarouselButton");
const _renderCarouselButton = require("./renderCarouselButton");
const _useCarouselButtonStylesstyles = require("./useCarouselButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselButton.useCarouselButton_unstable)(props, ref);
    (0, _useCarouselButtonStylesstyles.useCarouselButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselButtonStyles_unstable')(state);
    return (0, _renderCarouselButton.renderCarouselButton_unstable)(state);
});
CarouselButton.displayName = 'CarouselButton';
